@if (hasFilters) {
  <div
    class="md:min-h-[54px] px-xl py-base border-t border-ui-separator flex flex-col md:flex-row"
    [ngClass]="{
      'bg-primary/15': isAdvancedMode && !overviewKey,
      'border-t-0! pt-0! min-h-auto! px-base!': overviewKey
    }"
  >
    <div class="flex-1 flex flex-wrap gap-sm">
      @for (filter of filters; track filter) {
        @if (filter.text) {
          <div
            class="flex items-center px-base py-xs rounded-sm border border-primary text-sm leading-sm text-primary"
          >
            <lla-table-filter
              [advancedFilterKey]="advancedFilterKey"
              [filter]="tableActions.filters?.[filter.key] ?? { key: filter.key }"
              [sort]="tableActions.sort"
              (filterChanged)="onFilterChanged(filter.key, $event)"
            >
              <span>
                {{ filter.text }}
              </span>
            </lla-table-filter>
          </div>
        }
      }
    </div>
    @if (!overviewKey) {
      <div class="mt-base md:mt-0 self-end md:self-start flex items-center gap-lg">
        <lla-checkbox-element
          label="Advanced filters"
          [value]="!!isAdvancedMode"
          (click)="setAdvancedMode()"
        ></lla-checkbox-element>

        <ng-content></ng-content>
      </div>
    }
  </div>
}
